/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CheckinInstructions } from './CheckinInstructions';
import {
    CheckinInstructionsFromJSON,
    CheckinInstructionsFromJSONTyped,
    CheckinInstructionsToJSON,
    CheckinInstructionsToJSONTyped,
} from './CheckinInstructions';
import type { Policy } from './Policy';
import {
    PolicyFromJSON,
    PolicyFromJSONTyped,
    PolicyToJSON,
    PolicyToJSONTyped,
} from './Policy';
import type { RoomSummaryV3 } from './RoomSummaryV3';
import {
    RoomSummaryV3FromJSON,
    RoomSummaryV3FromJSONTyped,
    RoomSummaryV3ToJSON,
    RoomSummaryV3ToJSONTyped,
} from './RoomSummaryV3';
import type { CheckoutInstructions } from './CheckoutInstructions';
import {
    CheckoutInstructionsFromJSON,
    CheckoutInstructionsFromJSONTyped,
    CheckoutInstructionsToJSON,
    CheckoutInstructionsToJSONTyped,
} from './CheckoutInstructions';
import type { PropertyFee } from './PropertyFee';
import {
    PropertyFeeFromJSON,
    PropertyFeeFromJSONTyped,
    PropertyFeeToJSON,
    PropertyFeeToJSONTyped,
} from './PropertyFee';
import type { HotelSummary } from './HotelSummary';
import {
    HotelSummaryFromJSON,
    HotelSummaryFromJSONTyped,
    HotelSummaryToJSON,
    HotelSummaryToJSONTyped,
} from './HotelSummary';
import type { EarningsSummary } from './EarningsSummary';
import {
    EarningsSummaryFromJSON,
    EarningsSummaryFromJSONTyped,
    EarningsSummaryToJSON,
    EarningsSummaryToJSONTyped,
} from './EarningsSummary';

/**
 * Hotel details
 * @export
 * @interface HotelDetailsV3
 */
export interface HotelDetailsV3 {
    /**
     * 
     * @type {HotelSummary}
     * @memberof HotelDetailsV3
     */
    hotelSummary: HotelSummary;
    /**
     * 
     * @type {Array<RoomSummaryV3>}
     * @memberof HotelDetailsV3
     */
    roomSummaries?: Array<RoomSummaryV3>;
    /**
     * 
     * @type {CheckinInstructions}
     * @memberof HotelDetailsV3
     */
    checkinInstructions: CheckinInstructions;
    /**
     * 
     * @type {CheckoutInstructions}
     * @memberof HotelDetailsV3
     */
    checkoutInstructions: CheckoutInstructions;
    /**
     * 
     * @type {string}
     * @memberof HotelDetailsV3
     */
    mandatoryFeeInformation?: string;
    /**
     * 
     * @type {Array<Policy>}
     * @memberof HotelDetailsV3
     */
    policies: Array<Policy>;
    /**
     * 
     * @type {Array<PropertyFee>}
     * @memberof HotelDetailsV3
     */
    propertyFees?: Array<PropertyFee>;
    /**
     * The token to pass to the additional rates route
     * @type {string}
     * @memberof HotelDetailsV3
     */
    additionalRateToken?: string;
    /**
     * 
     * @type {EarningsSummary}
     * @memberof HotelDetailsV3
     */
    earningsSummary?: EarningsSummary;
}

/**
 * Check if a given object implements the HotelDetailsV3 interface.
 */
export function instanceOfHotelDetailsV3(value: object): value is HotelDetailsV3 {
    if (!('hotelSummary' in value) || value['hotelSummary'] === undefined) return false;
    if (!('checkinInstructions' in value) || value['checkinInstructions'] === undefined) return false;
    if (!('checkoutInstructions' in value) || value['checkoutInstructions'] === undefined) return false;
    if (!('policies' in value) || value['policies'] === undefined) return false;
    return true;
}

export function HotelDetailsV3FromJSON(json: any): HotelDetailsV3 {
    return HotelDetailsV3FromJSONTyped(json, false);
}

export function HotelDetailsV3FromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelDetailsV3 {
    if (json == null) {
        return json;
    }
    return {
        
        'hotelSummary': HotelSummaryFromJSON(json['hotel_summary']),
        'roomSummaries': json['room_summaries'] == null ? undefined : ((json['room_summaries'] as Array<any>).map(RoomSummaryV3FromJSON)),
        'checkinInstructions': CheckinInstructionsFromJSON(json['checkin_instructions']),
        'checkoutInstructions': CheckoutInstructionsFromJSON(json['checkout_instructions']),
        'mandatoryFeeInformation': json['mandatory_fee_information'] == null ? undefined : json['mandatory_fee_information'],
        'policies': ((json['policies'] as Array<any>).map(PolicyFromJSON)),
        'propertyFees': json['property_fees'] == null ? undefined : ((json['property_fees'] as Array<any>).map(PropertyFeeFromJSON)),
        'additionalRateToken': json['additional_rate_token'] == null ? undefined : json['additional_rate_token'],
        'earningsSummary': json['earnings_summary'] == null ? undefined : EarningsSummaryFromJSON(json['earnings_summary']),
    };
}

export function HotelDetailsV3ToJSON(json: any): HotelDetailsV3 {
    return HotelDetailsV3ToJSONTyped(json, false);
}

export function HotelDetailsV3ToJSONTyped(value?: HotelDetailsV3 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hotel_summary': HotelSummaryToJSON(value['hotelSummary']),
        'room_summaries': value['roomSummaries'] == null ? undefined : ((value['roomSummaries'] as Array<any>).map(RoomSummaryV3ToJSON)),
        'checkin_instructions': CheckinInstructionsToJSON(value['checkinInstructions']),
        'checkout_instructions': CheckoutInstructionsToJSON(value['checkoutInstructions']),
        'mandatory_fee_information': value['mandatoryFeeInformation'],
        'policies': ((value['policies'] as Array<any>).map(PolicyToJSON)),
        'property_fees': value['propertyFees'] == null ? undefined : ((value['propertyFees'] as Array<any>).map(PropertyFeeToJSON)),
        'additional_rate_token': value['additionalRateToken'],
        'earnings_summary': EarningsSummaryToJSON(value['earningsSummary']),
    };
}

